import React, { useCallback, useState } from 'react';

import { errMsg } from '@/components/PageElement/ErrorMessage';
import { successMsg } from '@/components/PageElement/SuccessMessage';
import Modal from '@/components/PageElement/Modal';
import { addProjecWhitelist } from 'api/project/project_add_whitelist';
import { useValidateAddr } from 'lib/useValidateAddr';

interface IAddWhitelistProps {
  openAdd: boolean;
  toggleAdd: () => void;
  id: number;
  getProjectWhitelistRaffle: (isUpdate?: boolean) => void;
}

const AddWhitelist: React.FC<IAddWhitelistProps> = ({
  openAdd,
  toggleAdd,
  id,
  getProjectWhitelistRaffle,
}) => {
  const { isValidAddr } = useValidateAddr();
  const [inputAddress, setInputAddress] = useState('');
  const [isFocusAddress, setIsFocusAddress] = useState(false);

  const handleClose = useCallback(() => {
    toggleAdd();
    setInputAddress('');
  }, [toggleAdd]);

  const handleConfirm = useCallback(async () => {
    if (!inputAddress) {
      errMsg('Address is required');
    } else if (!isValidAddr(inputAddress, 'ALL')) {
      errMsg('Invalid address');
    } else {
      const res = await addProjecWhitelist(id, inputAddress.trim());
      if (res?.code === 101) {
        errMsg('Address has already added');
      } else if (res?.code === 0) {
        successMsg('Address saved');
        handleClose();
        getProjectWhitelistRaffle(true);
      } else {
        errMsg(res?.msg);
      }
    }
  }, [getProjectWhitelistRaffle, handleClose, id, inputAddress, isValidAddr]);

  return (
    <Modal
      open={openAdd}
      handleCancel={handleClose}
      handleConfirm={handleConfirm}
      title="Add whitelist address"
    >
      <div>
        <div className="relative mb-6 flex h-[72px] items-center gap-2 rounded-2xl border border-neutral-600">
          <input
            type="text"
            className="peer h-full w-full rounded-2xl border-none !bg-neutral-900 px-5 text-white placeholder:text-neutral-500 placeholder:peer-focus:hidden"
            placeholder={isFocusAddress ? '' : '+ Mint wallet'}
            onChange={(e) => {
              setInputAddress(e.target.value);
            }}
            value={inputAddress}
            onFocus={() => {
              setIsFocusAddress(true);
            }}
            onBlur={() => {
              setIsFocusAddress(false);
            }}
          />
          <div className="absolute -top-4 left-3 hidden bg-neutral-900 px-2 py-1 text-center text-sm font-normal  text-white peer-focus:block">
            Mint wallet
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddWhitelist;
